export const getDefaultTemplateSettingsValues = (
  { id, status, template, type, assets, lastModified, ...defaultValues },
  appearanceSettings,
) => ({ ...defaultValues, appearanceSettings });
